import React from 'react';
import {AISearch} from "../../components/AISearch";

export const AISearchPage = () => {
    return (
        <AISearch />
    );
}
